var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[(_vm.medicalbusiness && _vm.medicalbusiness.logo)?_c('a',[_c('img',{staticClass:"logo",attrs:{"src":_vm.medicalbusiness.logo}})]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }